import { useState, useEffect, useRef, useCallback } from 'react';

const FadeIn = ({ children, delay = 0, className = '' }) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const handleIntersection = useCallback(
    (entries, observer) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        const timer = setTimeout(() => setIsVisible(true), delay);
        observer.unobserve(entry.target);
        return () => clearTimeout(timer);
      }
    },
    [delay]
  );

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.1,
    });
    observer.observe(element);

    return () => observer.disconnect();
  }, [handleIntersection]);

  return (
    <div
      ref={ref}
      className={`transition-all duration-1000 ease-out ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      } ${className}`}
    >
      {children}
    </div>
  );
};

export default FadeIn;
